import { Outlet } from "react-router-dom";
import AdminNavigation from "../components/admin/AdminNavigation.jsx"

function AdminLayout() {
  return(
    <>
      <main>
        <AdminNavigation/>
        <Outlet/>
      </main>
    </>
  )
}


export default AdminLayout
